import { http } from "../http-common";

const fetchWoodLogs = (query) => {
    let url = `/wood-supplier-import/logs?importId=${query.id}`;
    if (query.status) {
      url += `&status=${query.status}`;
    }
    if (query.pageNumber !== undefined) {
      url += `&pageNumber=${query.pageNumber}`;
    }
    if (query.size !== undefined) {
      url += `&size=${query.size}`;
    }
    return http.get(url);
  };

  const fetchWoodDetail = (query) => {
    return http.get(`/wood-supplier-import/log/${query.id}`);
  };

const WoodService = {
    fetchWoodLogs,
    fetchWoodDetail
};

export default WoodService;